import React from 'react';
import cls from 'classnames';
import { useI18n } from '../../_contexts/I18nContext';
import Anchor from '@/components/Anchor';
import Section, { SectionHeader } from '../Section';
import { logger } from '@/pages/business/utils/lib';
import styles from './index.module.scss';
import ScrollAnim from 'rc-scroll-anim';
const ScrollElement = ScrollAnim.Element;

const QRCode = ({
  className,
  name,
  title,
  desc,
  list
}) => {
  const I18n = useI18n();
  return /*#__PURE__*/React.createElement(ScrollElement, {
    id: "HTJ"
  }, /*#__PURE__*/React.createElement(Section, {
    className: cls(styles.container, className),
    name: name
  }, /*#__PURE__*/React.createElement(SectionHeader, {
    className: styles.header
  }, /*#__PURE__*/React.createElement("h1", null, title), /*#__PURE__*/React.createElement("p", null, desc)), /*#__PURE__*/React.createElement("ul", null, list.map((item, index) => /*#__PURE__*/React.createElement("li", {
    key: index
  }, /*#__PURE__*/React.createElement("p", null, I18n.t('TTS_Portal_Creator_HTJ_uk_text'), /*#__PURE__*/React.createElement(Anchor, {
    target: "_blank",
    href: item.link,
    onClick: () => {
      if (item.clickFor) {
        logger.sendButtonClick({
          click_for: item.clickFor
        });
      }
    }
  }, I18n.t('TTS_Portal_Creator_HTJ_uk_here')), I18n.t('TTS_Portal_Creator_HTJ_uk_to_apply')))))));
};

export default QRCode;